import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const affinityHubService = {
    getScoreByAffinity: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.CALCULATE_SCORE}`);
    },
    getYearsOfExperience: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.YEARS_OF_EXPERIENCE}`);
    },
    getSpecialtiesData: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.SPECIALTIES_DATA}`);
    },
    getDistributionByLocation: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.TOP_STATES_BY_INDIVIDUALS}`);
    },
    getDigitalVsNonDigitalAffinity: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.DIGITAL_VS_NON_DIG_AFFINITY}`);
    },
    getPersonalPromotionChannelAffinity: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.PERSONAL_PROMOTION_CHANNEL_AFFINITY}`);
    },
    getPeerPeerAffinityData: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.PEER_PEER_AFFINITY_DATA}`);
    },
    getDynamicTopicCounts: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.DYNAMIC_TOPIC_COUNTS}`);
    },
    getBrandedUnbrandedCounts: () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.BRANDED_UNBRANDED_COUNTS}`);
    },
    getDistributionByYearsOfExperience : () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.DISTRIBUTION_EXPERIENCE}`);
    },
    getRegionCount : () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.REGION_COUNT}`);
    },
    getDigitalChannelAffinity : () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.DIGITAL_CHANNEL_AFFINITY}`);
    },
    getContentAffinityKeywords : () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.CONTENT_AFFINITY_KEYWORDS}`);
    }, 
    getVendorAffinity : () => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.AFFINITY_REPORT}/${API_PATH.VENDOR_AFFINITY}`);
    }, 
};

export default affinityHubService;